import DevicePicker from './DevicePicker';
export default DevicePicker;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/components/DevicePicker/index.js